import React from 'react';
import { IProps as IBlockProps } from '@/blocks/LogoBlock/LogoBlock.interface';
import { LogoBlock } from './LogoBlock.component';
import TranslationComponent from '@/utils/TranslationComponent/TranslationComponent';
import * as translation from '@/utils/TranslationComponent/translation.utilities';

interface IBlockInputProps {
    title?: string;
    logos?: {
        image: {
            alternateText: string;
            defaultSrc: string;
            sizesAttribute: string[];
            srcSet: string[];
            srcSetWebp: string[];
            isBackground: boolean;
            textContent: string;
            isLazy: boolean;
        },
        link: React.HTMLProps<HTMLAnchorElement>;
    }[];
    autoScroll?: boolean;
    [key: string]: any;
}

const mapInputToProps = (input: IBlockInputProps): IBlockProps => {
    const { title, logos, ...rest } = input;
    return {
        ...input,
        title: title || undefined,
        logos: logos && logos.length > 0 ? logos?.map((logo) => {
            const { image, link } = logo;
            return {
                image: image ? translation.mapImageProps(image) : undefined,
                link: link ? translation.mapAnchorProps(link) : undefined,
            };
        }) : undefined,
        ...rest,
    } as IBlockProps;
};

const BlockTranslation: React.FC<IBlockInputProps> = (inputProps) => (
    <TranslationComponent
        inputProps={inputProps}
        TargetComponent={LogoBlock}
        mapProps={mapInputToProps}
    />
);

export default BlockTranslation;
